export default function About() {
  return (
    <section id="about" className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-white"></div>
      
      <div className="absolute top-0 right-0 w-2/5 h-full bg-[#00D4FF] transform skew-x-[-15deg] origin-top-right">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-10 w-32 h-32 border-4 border-[#0A1628] rounded-full"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-[#0A1628] transform rotate-45"></div>
          <div className="absolute bottom-32 left-1/3 w-40 h-40 border-4 border-[#0A1628]"></div>
          <div className="absolute bottom-20 right-10 w-20 h-20 bg-[#0A1628] rounded-full"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <span className="text-[#00D4FF] text-sm font-semibold tracking-[3px] uppercase">
              ABOUT VIAPREC S.R.L.
            </span>
            
            <h2 className="text-5xl md:text-6xl font-bold text-[#0A1628] leading-tight">
              Protecting Digital Rights Since Day One
            </h2>
            
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                VIAPREC S.R.L. is a technology company dedicated to protecting your digital privacy and freedom. Based in Rosario, Argentina, we develop cutting-edge VPN solutions that empower individuals and businesses to browse the internet securely and anonymously.
              </p>
              
              <p>
                Our mission is simple: to make online privacy accessible to everyone. We believe that internet freedom is a fundamental right, and we're committed to providing the tools necessary to protect that right in an increasingly connected world.
              </p>
              
              <p>
                With our state-of-the-art encryption technology and global server network, we ensure that your online activities remain private, secure, and unrestricted. Whether you're protecting sensitive business data or simply browsing the web, VIAPREC has you covered.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#00D4FF] mb-2">60+</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide">Countries</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#00D4FF] mb-2">256-bit</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide">Encryption</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#00D4FF] mb-2">24/7</div>
                <div className="text-sm text-gray-600 uppercase tracking-wide">Support</div>
              </div>
            </div>
          </div>

          <div className="relative hidden md:block">
            <div className="relative w-full h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/3e275b3d29f32988d2a39dff047b37f2.jpg"
                alt="Digital Security Concept"
                className="w-full h-full object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
